import GuideLayoutV1 from '@/components/app/guide/GuideLayout';
import { Guide } from '@/store/guide/types';
import { Program } from '@/store/program/types';

type GuideLayoutProps = {
	guide: Guide | null;
	program: Program | null;
	rotateBackButton?: boolean;
};

const GuideLayout = ({ guide, program, rotateBackButton }: GuideLayoutProps) => {
	if (!guide || !program) {
		return null;
	}

	return <GuideLayoutV1 guide={guide} program={program} rotateBackButton={rotateBackButton} />;
};

export default GuideLayout;
